const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';
const TENANT_SLUG = import.meta.env.VITE_TENANT_SLUG || '';

export interface ClerkSessionResponse {
  token: string;
  user: {
    sso_user_id: string;
    username: string;
    email?: string;
  };
}

/**
 * Exchange a Clerk session JWT for the internal application JWT (HS256).
 * Same contract as the pickem frontend's exchange — the returned token is
 * what `apiClient` sends as the bearer for all /api/squads/* calls.
 *
 * Uses plain fetch rather than `apiClient`: the axios request interceptor
 * overwrites the Authorization header with the stored internal token, but
 * this request must carry the Clerk session token instead.
 */
export async function exchangeClerkSession(
  clerkSessionToken: string
): Promise<ClerkSessionResponse> {
  const response = await fetch(`${API_URL}/api/auth/clerk/session`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${clerkSessionToken}`,
      'Content-Type': 'application/json',
      'X-Tenant-Slug': TENANT_SLUG,
    },
  });

  if (!response.ok) {
    const body = (await response.json().catch(() => ({}))) as { message?: string; error?: string };
    throw new Error(
      body.message || body.error || `Clerk session exchange failed (${response.status})`
    );
  }

  return response.json() as Promise<ClerkSessionResponse>;
}
